<div class="schedule-table-container">
  <!-- Toolbar -->
  <div class="schedule-table-toolbar mb-3">
    <div class="row justify-content-end g-2">
      <div class="col-12 col-xl-auto">
        <div class="row g-2">
          <div class="col-12 col-md">
            <div class="input-group">
              <input
                type="search"
                class="form-control"
                placeholder="Search"
                [value]="searchValue"
                (keyup.enter)="
                  search(
                    $any($event.target).value
                  )
                "
                (search)="
                  search(
                    $any($event.target).value
                  )
                "
                #searchInput
              />

              <button
                class="btn btn-primary"
                type="button"
                (click)="
                  search(searchInput.value)
                "
              >
                <i
                  class="fa fa-search me-1"
                ></i>

                Search
              </button>

              <button
                *ngIf="searchValue"
                class="btn btn-outline-secondary"
                type="button"
                (click)="
                  clearSearch(searchInput)
                "
              >
                Clear
              </button>
            </div>
          </div>

          <div
            class="col-12 col-md-auto"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="schedule-table-wrap">
    <table
      class="table schedule-table align-middle"
    >
      <thead>
        <tr>
          <th>
            Schedule ID
          </th>

          <th>
            Source
          </th>

          <th>
            Project Name
          </th>

          <th>
            Item Category
          </th>

          <th>
            Item ID
          </th>

          <th>
            Status
          </th>

          <th>
            <button
              type="button"
              class="table-sort-btn"
              (click)="
                toggleScheduledForSort()
              "
            >
              Scheduled For

              <fa-icon
                class="sort-icon"
                [icon]="
                  getScheduledForSortIcon()
                "
              ></fa-icon>
            </button>
          </th>

          <th>
            Action
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let row of sortedRows();
            trackBy: trackByScheduleRow
          "
        >
          <!-- Schedule ID -->
          <td>
            {{ row.scheduleId }}
          </td>

          <!-- Source -->
          <td>
            <a
              class="source-link"
              role="button"
              (click)="viewJobModal(row)"
            >
              {{ row.source }}
            </a>
          </td>

          <!-- Project Name -->
          <td>
            {{ row.projectName }}
          </td>

          <!-- Item Category -->
          <td>
            {{ row.itemCategory }}
          </td>

          <!-- Item ID -->
          <td>
            {{ row.itemId }}
          </td>

          <!-- Status -->
          <td>
            <span
              [class]="
                getStatusClass(row.status)
              "
            >
              <span
                class="status-dot"
              ></span>

              {{ row.status }}
            </span>
          </td>

          <!-- Scheduled For -->
          <td>
            {{
              formatDateTime(
                row.scheduledFor
              )
            }}
          </td>

          <!-- Actions -->
          <td>
            <div class="action-buttons">
              <button
                type="button"
                class="btn btn-outline-primary table-action-btn"
                [disabled]="!canRetry(row)"
                (click)="onRetry(row)"
              >
                Retry
              </button>

              <button
                type="button"
                class="btn btn-outline-error table-action-btn"
                [disabled]="
                  !canCancel(row)
                "
                (click)="
                  openDeleteContactConfirmationModal(
                    row
                  )
                "
              >
                Cancel
              </button>

              <button
                type="button"
                class="btn btn-outline-primary table-action-btn"
                [disabled]="
                  !canReschedule(row)
                "
                (click)="
                  openRescheduleModal(row)
                "
              >
                Reschedule
              </button>
            </div>
          </td>
        </tr>

        <!-- Empty State -->
        <tr *ngIf="rows().length === 0">
          <td colspan="8">
            <div class="empty-state">
              No schedules found.
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div
    *ngIf="totalCount > 0"
    class="row table-controls automation-table__footer mt-3"
  >
    <!-- Limit -->
    <div class="col">
      <div
        ngbDropdown
        placement="top-left"
        class="d-inline-block"
      >
        <button
          class="btn page-size-btn"
          ngbDropdownToggle
        >
          {{ limit }}
        </button>

        <div
          ngbDropdownMenu
          class="page-size-dropdown"
        >
          <button
            ngbDropdownItem
            (click)="setLimit(5)"
          >
            5
          </button>

          <button
            ngbDropdownItem
            (click)="setLimit(10)"
          >
            10
          </button>

          <button
            ngbDropdownItem
            (click)="setLimit(20)"
          >
            20
          </button>
        </div>
      </div>
    </div>

    <!-- Pages -->
    <div class="col">
      <ngb-pagination
        class="d-flex justify-content-end custom-pagination"
        [page]="page"
        [pageSize]="limit"
        [collectionSize]="totalCount"
        [boundaryLinks]="true"
        [maxSize]="1"
        [ellipses]="true"
        [rotate]="true"
        (pageChange)="
          setCurrentPage($event)
        "
      ></ngb-pagination>
    </div>
  </div>
</div>